var React = require('react');

function Twitter32 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 11.1472C23.4 11.4372 22.8 11.5339 22.1 11.6306C22.8 11.2439 23.3 10.6638 23.5 9.89038C22.9 10.2771 22.2 10.4704 21.4 10.6638C20.8 10.0837 19.9 9.69702 19 9.69702C16.9 9.69702 15.3 11.6306 15.8 13.5642C13.1 13.4675 10.7 12.2107 9 10.2771C8.1 11.7273 8.6 13.5642 10 14.5309C9.5 14.5309 9 14.3376 8.5 14.1442C8.5 15.5944 9.6 16.9479 11.1 17.3346C10.6 17.4313 10.1 17.528 9.6 17.4313C10 18.6881 11.2 19.6549 12.7 19.6549C11.5 20.525 9.7 21.0084 8 20.815C9.5 21.6852 11.2 22.2652 13 22.2652C19.1 22.2652 22.5 17.3346 22.3 12.7907C23 12.404 23.6 11.8239 24 11.1472Z","fill":"white"}));
}

Twitter32.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Twitter32;

Twitter32.default = Twitter32;
